import { render, staticRenderFns } from "./TheNotificationDetail.vue?vue&type=template&id=8f9d0d96&"
import script from "./TheNotificationDetail.vue?vue&type=script&lang=js&"
export * from "./TheNotificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports